import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const Security = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Security</h3>
      <p>
        We take reasonable measures to protect your personal information from
        unauthorized access, use, or disclosure. These measures include:
      </p>
      <ul>
        <li>
          Encryption of sensitive data, such as payment information, during
          transmission.
        </li>
        <li>Secure servers and firewalls to protect stored data.</li>
        <li>
          Regular monitoring of our systems for potential vulnerabilities and
          attacks.
        </li>
      </ul>
      <p>
        While we strive to protect your personal information, no method of
        transmission over the Internet or electronic storage is 100% secure.
        Therefore, we cannot guarantee absolute security.
      </p>
      <p>
        Users are responsible for maintaining the confidentiality of their
        account credentials and for restricting access to their accounts. If you
        suspect any unauthorized access to your account, please contact us
        immediately at{' '}
        <a href="mailto:yodasafeetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        .
      </p>
      <p>
        In the event of a data breach, we will take appropriate steps to notify
        affected users and comply with applicable laws and regulations.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Security;
